import React, { useState } from "react";
import { Layout, Card, Col, Row, Spin, Button } from "antd";
import ds from "../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useStore, useDispatch, useSelector } from "react-redux";
import IntlMessages from "../util/IntlMessages";

const SetProductLayout = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [visible, setVisible] = React.useState(false);

  return (
    <div className="Quick-Keys">
      <Row justify="center" className="dk-row-default m-0">
        <Col>
          <div className={`dk-quick-key droptarget dk-quick-key--hover 0`} >
            <div className="gx-card key-card overflow-hidden mb-0">
              <div className="qk-card-head" style={{ backgroundColor: "rgb(98, 103, 111)" }} ></div>
              <div className="dk-quick-key-card-body">
                <h3 className="custom-text-center dk-quick-key-label mb-0">
                  <strong>{"Necklace"}</strong>
                </h3>
              </div>
            </div>
          </div>
        </Col>

        <Col>
          <div className={`dk-quick-key droptarget dk-quick-key--hover 0`} >
            <div className="gx-card key-card overflow-hidden mb-0">
              <div className="qk-card-head" style={{ backgroundColor: "#41af4b" }} ></div>
              <div className="dk-quick-key-card-body">
                <h3 className="custom-text-center dk-quick-key-label mb-0">
                  <strong>{"Bracelet"}</strong>
                </h3>
              </div>
            </div>
          </div>
        </Col>

        <Col>
          <div className={`dk-quick-key droptarget dk-quick-key--hover 0`} >
            <div className="gx-card key-card overflow-hidden mb-0">
              <div className="qk-card-head" style={{ backgroundColor: "#1890ff" }} ></div>
              <div className="dk-quick-key-card-body">
                <h3 className="custom-text-center dk-quick-key-label mb-0">
                  <strong>{"Shirt"}</strong>
                </h3>
              </div>
            </div>
          </div>
        </Col>

        <Col>
          <div className={`dk-quick-key droptarget dk-quick-key--hover 0`} >
            <div className="gx-card key-card overflow-hidden mb-0">
              <div className="qk-card-head" style={{ backgroundColor: "rgb(215, 113, 115)" }} ></div>
              <div className="dk-quick-key-card-body">
                <h3 className="custom-text-center dk-quick-key-label mb-0" >
                  <strong>{"Shoes"}</strong>
                </h3>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row justify="center" className="mt-4 mb-4 mx-0">
        <Col lg={24} md={24} sm={24} xs={24}>
          <h2 className="mb-0 text-center"> <IntlMessages id="sell.layout.desc" /> </h2>
        </Col>
      </Row>

      <Row justify="center" className="m-0  text-center">
      <Col lg={24} md={24} sm={24} xs={24}>
          <Button type="primary" size="large" onClick={() => history.push("/dashboard/sell/settings/listing")} disabled={!isOnline} >
            <IntlMessages id="dashbaord.main.setquick" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SetProductLayout;
